module.exports = __webpack_public_path__ + "static/img/14.698b8a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/14.jpg
// module id = gX/g
// module chunks = 1